var _style, _g, _g2, _rect, _rect2, _rect3, _g3, _rect4, _rect5, _rect6, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverviewicona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 216.3 216.3",
    style: {
      enableBackground: "new 0 0 216.3 216.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{fill-rule:evenodd;clip-rule:evenodd;stroke:#000000;stroke-width:20.84;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n\t.st2{stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:4.9978;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    xmlnsSerif: "http://www.serif.com/"
  }, /*#__PURE__*/React.createElement("g", {
    id: "speedometer-1--1--1-",
    transform: "matrix(26.8252,0,0,26.8252,561.907,1348.62)",
    serifId: "speedometer(1) 1 (1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 29,
    height: 29,
    id: "_Image1",
    xlinkHref: "62856A207566849F.png",
    transform: "matrix(0.2399 0 0 0.2399 -20.4051 -49.8907)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.919045,0,0,1.07388,-17.5175,56.0587)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226.5,109.3c9.1-12.9,13.9-27.5,13.9-42.4c0-46.8-46.5-84.8-103.8-84.8c-57.3,0-103.8,38-103.8,84.8 c0,14.9,4.8,29.5,13.9,42.4H226.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.642203,0,0,0.750397,274.253,577.493)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-169-561.7c9.1-12.9,13.9-27.5,13.9-42.4c0-46.8-46.5-84.8-103.8-84.8c-57.3,0-103.8,38-103.8,84.8 c0,14.9,4.8,29.5,13.9,42.4H-169z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.3,
    y: 148.5,
    className: "st2",
    width: 167.8,
    height: 22.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 174.7,
    y: 120.7,
    className: "st3",
    width: 41.6,
    height: 15.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82.1,
    y: 26.9,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 142.642 -73.0699)",
    className: "st3",
    width: 51.6,
    height: 15.8
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6345,0.772923,-0.772923,0.6345,1798.71,-247.008)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-777.8,1484.7c0,0-12.1,45.8-12.1,65.4c0,6.7,5.4,12.1,12.1,12.1c6.7,0,12.1-5.4,12.1-12.1 C-765.6,1530.5-777.8,1484.7-777.8,1484.7z"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.8,
    y: 60.4,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 60.0321 -8.2529)",
    className: "st3",
    width: 46.3,
    height: 15.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 148.6,
    y: 59.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 3.104 142.2628)",
    className: "st3",
    width: 49.4,
    height: 15.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 120.7,
    className: "st3",
    width: 40,
    height: 15.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewicona);
export default __webpack_public_path__ + "static/media/overviewicona.78981faad667fe9bd88f8517d94fe04d.svg";
export { ForwardRef as ReactComponent };